// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-DocumentUploader-module__loadingSpinner";
export { _1 as "loadingSpinner" }
